import React, { useState, useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Grid, useMediaQuery } from "@material-ui/core"

import {
    ButtonHLPure,
    InputHLPure,
    TextAreaHLPure,
    InputFileHLPure,
    DialogSystemGLPure,
    ArrowBtnHLPure,
    ConfirmationDataModal
} from "../../../pures"
import "./digital-contract-template-detail.css"
import PdfViewerAction from '../../../actions/pdf-viewer/pdf-viewer.action'

const DigitalContractTemplatesDetailView = (props) => {
    let {
        selectedTemplate,
        hideShowDetails,
        setStateNameComponentUser,
        setHeaderTitleinDetail,
        setShowComponentDetail,
        setLastStateNameComponentUser,
        getVariablesFromDoc,
        getTemplatebyPath,
        updateTemplate,
        showCompletedRequesting,
        showErrorRequesting,
        showLoadingRequesting,
        toggleErrorRequesting,
        toggleCompletedRequesting,
        toggleLoadingRequesting,
        message,
        options,
        editTemplate
    } = props

    const { t } = useTranslation()
    const isStandardTemplate = selectedTemplate.clientId == null && selectedTemplate.companyId == null

    const [selectedFile, setSelectedFile] = useState(false)
    const [errorFile, setErrorFile] = useState(false)
    const [selectedFileName, setSelectedFileName] = useState(false)
    const [deletePfd, setDeletePfd] = useState(false)
    const [selectedFileBase64, setSelectedFileBase64] = useState(false)
    const [name, setName] = useState(selectedTemplate.name)
    const [description, setDescription] = useState(selectedTemplate.description)
    const [quantity, setQuantity] = useState(selectedTemplate.variableCount)
    const [selectedCompany, setSelectedCompany] = useState(t("questionnairesAssignCategories.no.assign"))
    const [file, setFile] = useState('')
    const [displayPdf, setDisplayPdf] = useState(true)
    const [showAWS, setShowAws] = useState(true)
    const [urlPdf, setUrlPdf] = useState('')
    const [blobUrl, setBlobUrl] = useState("")
    const [confirmationData, setConfirmationData] = useState()


    const pdf = useMemo(() => {
        return <PdfViewerAction url={blobUrl} isExtended={false} isSSRActive={false} />
    }, [blobUrl])
    const pdfAws = useMemo(() => <PdfViewerAction url={urlPdf} isExtended={false} isSSRActive={false} />, [urlPdf])

    const isMobile = useMediaQuery("(max-width:560px)");

    useEffect(() => {
        return () => {
            if (blobUrl) {
                URL.revokeObjectURL(blobUrl)
            }
        }
    }, [blobUrl])

    useEffect(() => {
        if (selectedTemplate.documentPathPdf !== null && selectedTemplate.documentPathPdf !== '') {
            setUrlPdf(selectedTemplate.documentPathPdf)
            let parts = selectedTemplate.documentPath.split('/')
            setSelectedFileName(parts[4])
            setSelectedFile(true)

            // let result = await getTemplatebyPath(selectedTemplate.documentPath)
            // const arr = new Uint8Array(result.data, DataTransferItem).buffer
            // setFile(arr)
        }

        if (selectedTemplate.clientId == null) {
            setSelectedCompany('Contratos Estándar')
        } else if (options) {
            options.map((arrayItem) => {
                if (selectedTemplate.companyId === arrayItem.id) {
                    setSelectedCompany(arrayItem.businessName)
                }
            })
        }
    }, []);

    const redirectToComponets = (name) => {
        setLastStateNameComponentUser(t("procedureAdministrationView.details"))
        setStateNameComponentUser(name);
        setHeaderTitleinDetail({ clicked: true, name: name })

    };

    const handleNameInput = (e) => {
        setName(e.target.value);
    };

    const handleQuantityInput = (e) => {
        setQuantity(e.target.value);
    };

    const handleDescriptionInput = (e) => {
        setDescription(e.target.value);
    };

    //Funtion to check the pdf extension
    const handleFile = async (e) => {
        if (!e.target.files[0]) return
        let errorMessage = 'Ocurrió un error al validar las variables del documento'
        let errorNoDocx = 'Solo se permiten archivos con extension .docx'
        toggleLoadingRequesting(true)
        //File extension .docx
        let result = e.target.files[0].name.slice(-5);
        if (result === ".docx" || result === ".DOCX") {
            setShowAws(false)
            setSelectedFile(e.target.files[0]);
            setSelectedFileName(e.target.files[0].name);
            setErrorFile(false);
            try {
                let documentVariable = await getVariablesFromDoc(e.target.files[0])
                if (documentVariable && documentVariable.data && Number(documentVariable.statusCode) === 200) {
                    setQuantity(documentVariable.data.Quantity)
                    const arr = new Uint8Array(documentVariable.data.pdfBuf.data).buffer
                    setFile(arr)
                    const blob = new Blob([arr], { type: 'application/pdf' })
                    const url = URL.createObjectURL(blob)
                    setBlobUrl(url)
                    toggleLoadingRequesting(false)
                    toggleCompletedRequesting(true)
                } else if (Number(documentVariable.statusCode) === -2) {
                    setSelectedFile(null);
                    setSelectedFileBase64("")
                    toggleLoadingRequesting(false)
                    toggleErrorRequesting(true, documentVariable.message)
                } else if (Number(documentVariable.statusCode) === -3) {
                    setSelectedFile(null);
                    setSelectedFileBase64("")
                    toggleLoadingRequesting(false)
                    toggleErrorRequesting(true, documentVariable.message)
                } else if (Number(documentVariable.statusCode) === -4) {
                    setSelectedFile(null);
                    setSelectedFileBase64("")
                    toggleLoadingRequesting(false)
                    toggleErrorRequesting(true, documentVariable.message)
                } else {
                    setSelectedFile(null);
                    setSelectedFileBase64("")
                    toggleLoadingRequesting(false)
                    toggleErrorRequesting(true, errorMessage)

                }
            } catch (error) {
                setSelectedFile(null);
                setErrorFile(true);
                setSelectedFileBase64("")
                toggleLoadingRequesting(false)
                toggleErrorRequesting(true, errorMessage)
            }
        } else {
            toggleLoadingRequesting(false)
            setSelectedFile(null);
            setErrorFile(true);
            setSelectedFileBase64("")
            toggleErrorRequesting(true, errorNoDocx)
            return false;
        }
    };


    //Function to delete the uploaded file
    const handleDeleteFile = (e) => {
        setSelectedFile(null);
        setErrorFile(false);
        setQuantity(0)
        setUrlPdf('')
        setFile('')
        if (blobUrl) {
            URL.revokeObjectURL(blobUrl)
            setBlobUrl('')
        }
        return true;
    };

    const handleSave = async (isConfirmed) => {
        setConfirmationData(null);

        const data = {
            id: selectedTemplate.id,
            companyId: selectedTemplate.companyId,
            name: name,
            description: description,
            isConfirmed,
        }
        // updateTemplate(data);
        if (typeof selectedFile !== 'boolean') {
            data.document = selectedFile
        }

        let confirmationData = await updateTemplate(data);
        setConfirmationData(confirmationData);
    };


    const filterChange = (e) => {
        const selectedOption = e.target.value;
        setSelectedCompany(selectedOption);
    };


    return (
        <>
            <Grid
                item
                className="digitalContractTemplatesDetails-body"
                xs={12}
            >
                {/*Container primera seccion de items, fila*/}
                <Grid
                    container
                    spacing={4}
                >
                    {/*Cada componente puro, estara envuelto en un grid item */}
                    {/* <Grid
                    item
                    lg={4}
                    md={4}
                    xs={12}
                    className="digitalContractTemplatesButton"
                > */}
                    <Grid
                        item
                        md={6}
                        xs={12}
                        className={displayPdf ? null : "digitalContractTemplateNone"}>
                        <Grid container spacing={2}>
                            <Grid xs={12} item>
                                <InputHLPure
                                    labelInput={t("digitalContractTemplatesDetail.Company")}
                                    typeInput={"text"}
                                    errorInputText={"Error"}
                                    tooltipShow={false}
                                    informationIcon={false}
                                    inputActive={true}
                                    valueInput={selectedCompany}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid xs={12} item>
                                <InputHLPure
                                    labelInput={t("digitalContractTemplatesDetail.Name")}
                                    typeInput={"text"}
                                    errorInputText={"Error"}
                                    tooltipShow={true}
                                    informationIcon={true}
                                    positionTooltip={isMobile ? "top" : "right"}
                                    titleTooltip={t("digitalContractTemplatesDetail.NameTooltipTitle")}
                                    descriptionTooltip={t("digitalContractTemplatesDetail.NameTooltipDescription")}
                                    valueInput={name}
                                    handleChangeInput={handleNameInput}
                                    inputActive={true}
                                    disabled={isStandardTemplate}
                                />
                            </Grid>

                            {
                                !isStandardTemplate &&
                                <Grid
                                    item xs={12}
                                    className="digitalContractTemplatesDetailsInputFile"
                                >
                                    <InputFileHLPure
                                        messageBtn={t("digitalContractTemplatesDetail.Document")}
                                        flex={false}
                                        acceptFile={".doc, .docx, application/msword"}
                                        selectedFile={selectedFile}
                                        selectedFileName={selectedFileName}
                                        errorFile={errorFile}
                                        handleFile={e => handleFile(e)}
                                        handleDeleteFile={e => handleDeleteFile(e)}
                                        tooltipShow={true}
                                        positionTooltip={isMobile ? "top" : "right"}
                                        titleTooltip={t('digitalContractTemplatesDetail.DocumentTooltipTitle')}
                                        descriptionTooltip={t('digitalContractTemplatesDetail.DocumentTooltipDescription')}
                                        labelActive={false}
                                        informationIcon={true}
                                    />
                                </Grid>
                            }

                            <Grid xs={12} item>
                                <InputHLPure
                                    labelInput={t("digitalContractTemplatesDetail.Variables")}
                                    typeInput={"text"}
                                    disabled={true}
                                    errorInputText={"Error"}
                                    valueInput={quantity}
                                    handleChangeInput={handleQuantityInput}
                                    inputActive={true}
                                />
                            </Grid>

                            <Grid xs={12} item>
                                <TextAreaHLPure
                                    labelTextArea={t("digitalContractTemplatesDetail.Description")}
                                    valueTextData={description}
                                    handleChangeTextArea={handleDescriptionInput}
                                    errorTextArea={"Error"}
                                    disabled={isStandardTemplate}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        {
                            urlPdf === '' && blobUrl === '' ?
                                <div className="digitalContractTemplatesDetailView-conatiner-no-pdf">
                                    {t("digitalContractDashboard.templates.details.noTemplateUploaded")}
                                </div>
                                :
                                <Grid item lg={12} md={12} sm={12} es={12} className="digitalContractTemplatesDetailView-conatiner-pdf">
                                    {(showAWS) ? pdfAws : pdf}
                                </Grid>
                        }
                    </Grid>
                    {/* </Grid> */}
                </Grid>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="digitalContractTemplatesDetailsButtons"
                >
                    <Grid
                        item
                        className={displayPdf ? "digitalContractTemplatesDetailsCancelButton" : "digitalContractTemplateNone"}
                    >
                        <ButtonHLPure primary={isStandardTemplate} nameBtn={t("button.cancel")} onClickBtn={hideShowDetails} />
                    </Grid>
                    {
                        !isStandardTemplate &&
                        <Grid
                            item
                            className={displayPdf ? "digitalContractTemplatesDetailsArrowButton" : "digitalContractTemplateNone"}
                        >
                            <ArrowBtnHLPure
                                textArrowBtn={t("digitalContractTemplatesDetail.buttonDelete")}
                                onClickArrowBtn={(e) => redirectToComponets(t("digitalContractDashboard.templates.routerDisable"))}
                            />
                        </Grid>
                    }
                    {
                        !isStandardTemplate &&
                        <Grid
                            item
                            className={displayPdf ? "digitalContractTemplatesDetailsArrowButton" : "digitalContractTemplateNone"}
                        >
                            <ArrowBtnHLPure
                                textArrowBtn={t("digitalContractDashboard.templates.editTemplate")}
                                onClickArrowBtn={(e) => editTemplate(selectedTemplate.id)}
                            />
                        </Grid>
                    }
                    <Grid
                        item
                        className={displayPdf ? "digitalContractTemplatesDetailsArrowButton" : "digitalContractTemplateNone"}
                    >
                        <ArrowBtnHLPure
                            textArrowBtn={t("digitalContractTemplatesDetail.buttonVariables")}
                            onClickArrowBtn={(e) => redirectToComponets('Variables')}
                        />
                    </Grid>
                    <Grid
                        item
                        className="digitalContractTemplatesAddArrowButton"
                    >
                        {/*TERMINAR AQUI*/}
                        <ArrowBtnHLPure
                            textArrowBtn={displayPdf ? 'Ver template' : "Regresar"}
                            // onClickArrowBtn={(e) => redirectToComponets('Pdf')}
                            onClickArrowBtn={(e) => setDisplayPdf(!displayPdf)}
                        />
                    </Grid>
                    {
                        !isStandardTemplate &&
                        <Grid
                            item
                            className={displayPdf ? "digitalContractTemplatesDetailsCancelButton" : "digitalContractTemplateNone"}
                        >
                            <ButtonHLPure primary nameBtn={t("button.save")} onClickBtn={() => handleSave(false)} />
                        </Grid>
                    }
                    <DialogSystemGLPure
                        showLoadingRequesting={showLoadingRequesting}
                        showCompletedRequesting={showCompletedRequesting}
                        showErrorRequesting={showErrorRequesting}
                        toggleLoadingRequesting={toggleLoadingRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}
                        toggleErrorRequesting={toggleErrorRequesting}
                        message={message}
                    />
                </Grid>
                {/*Seccion de fila para footer */}
            </Grid>
            {
                confirmationData &&
                <ConfirmationDataModal
                    submit={() => handleSave(true)}
                    confirmationData={confirmationData}
                    cancel={() => setConfirmationData(null)}
                    customStylesCancelButton={{ marginRight: 10 }}
                />
            }
        </>
    );
};

export default DigitalContractTemplatesDetailView;